import axiosInstance from "../../services/axiosInstance";
import { axiosWithAbort } from "../../services/axiosWithAbort";
import handleAPIError, { showSuccessToast } from "../../services/toast";
import commonStore from "../../Store/marco/commonStore";
export const boundarySettingsAPI = {
  //////// 取得邊界設定已儲存內容
  async getBSContent(requestBody) {
    const response = await axiosWithAbort(
      `getBSContent:${JSON.stringify(requestBody)}`,
      {
        method: "post",
        url: `/api/boundary/organization_boundary/get_boundary_setting`,
        data: requestBody,
      },
    );

    return response.data;
  },

  //////// 儲存組織邊界資料
  async saveBS(requestBody) {
    const response = await axiosWithAbort(`saveBS:${JSON.stringify(requestBody)}`, {
      method: "post",
      url: "/api/boundary/organization_boundary/upsert_boundary_setting",
      data: requestBody,
    });
    return response?.data;
  },

  //////// 新年份組織邊界的同步
  async syncBS(requestBody) {
    const response = await axiosWithAbort(`syncBS:${JSON.stringify(requestBody)}`, {
      method: "post",
      url: "/api/boundary/organization_boundary/sync",
      data: requestBody,
    });
    return response?.data;
  },

  //////// 刪除該年份的組織邊界資料
  async deleteBS(rootId, year) {
    const response = await axiosWithAbort(`deleteBS:${rootId}/${year}`, {
      method: "delete",
      url: `/api/boundary/organization_boundary/delete_all_setting/${rootId}/${year}`,
    });
    return response?.data;
  },

  //////// 取得已經設定過的年份
  async getSetYears(userId) {
    const response = await axiosWithAbort("getSetYears", {
      method: "get",
      url: `/api/report/get_report_year_dropdown?userId=${userId}&reportId=${1}`,
    });
    return response.data.data;
  },

  //////// 取得報告邊界的問題資料
  async getRBData(requestBody) {
    const response = await axiosWithAbort(
      `getRBData:${JSON.stringify(requestBody)}`,
      {
        method: "post",
        url: `/api/boundary/organization_boundary/get_significant_option`,
        data: requestBody,
      },
    );

    return response.data;
  },

  //////// 儲存報告邊界資料
  async saveRB(userId, year, isCustom, standardId, requestBody) {
    const response = await axiosWithAbort(`savedRB:${JSON.stringify(requestBody)}`, {
      method: "put",
      url: `/api/boundary/organization_boundary/upsert_significant_option?userId=${userId}&reportId=1&year=${year}&isCustom=${isCustom}&standardId=${standardId}`,
      data: requestBody,
    });
    return response?.data;
  },

  //////// 取得重大性評估的答案資料
  async getMaterialityData(requestBody) {
    const response = await axiosWithAbort(
      `getMaterialityData:${JSON.stringify(requestBody)}}`,
      {
        method: "post",
        url: `/api/boundary/organization_boundary/get_significant_answers`,
        data: requestBody,
      },
    );
    return response.data.data;
  },

  //////// 儲存重大性資料
  async saveMaterialityData(userId, year, isCustom, standardId, requestBody) {
    const response = await axiosWithAbort(`saveMaterialityData:${JSON.stringify(requestBody)}`, {
      method: "put",
      url: `/api/boundary/organization_boundary/upsert_significant_answers/${userId}/1/${year}/${isCustom}/${standardId}`,
      data: requestBody,
    });
    return response?.data;
  },

  //////// 取得稽核紀錄
  async getLog(userId, year) {
    const response = await axiosWithAbort(`getLog:${userId}/${year}`, {
      method: "get",
      url: `/api/boundary/organization_boundary/boundary_remark_list/${userId}/${year}`,
    });

    return response.data.data;
  },

  ////////取得已設定年份下拉式清單
  async getReportYearDropdownAPI(userId) {
    try {
      const response = await axiosInstance.get(
        `/api/report/get_report_year_dropdown?userId=${userId}&reportId=${1}`,
      );
      return response.data.data;
    } catch (error) {
      handleAPIError(error);
      console.error(error);
      return null;
    }
  },

  ////////拿取報告邊界年分
  async getReportYearOption(userId, reportId) {
    try {
      const response = await axiosInstance.get(
        `/api/boundary/organization_boundary/get_significant_option_year_dropdown/${userId}/${reportId}`,
      );

      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "拿取報告邊界年分失敗");
      console.error(err);
    }
  },

  ////////取得重大性評估後的排放活動類別
  async getEACategory(rootId, year, standardId) {
    try {
      const response = await axiosWithAbort("getEACategory", {
        method: "POST",
        url: `/api/boundary/organization_boundary/get_available_category_system/${rootId}/${year}/${standardId}`,
      });

      return response.data.data;
    } catch (err) {
      //  handleAPIError(err, "拿取重大性評估年分失敗");
      console.error(err);
    }
  },

  //////// 檢查設定年與基準年標準是否一致
  async getDecarbonCategoryDropdown(requestBody) {
    const response = await axiosWithAbort(
      `getDecarbonCategoryDropdown:${JSON.stringify(requestBody)}`,
      {
        method: "POST",
        url: `/api/boundary/organization_boundary/get_decarbon_category_dropdown`,
        data: requestBody,
      },
    );

    return response.data.data;
  },

  async checkStandardByYear(userId, originalYear, targetYear) {
    const response = await axiosWithAbort("checkStandard", {
      method: "GET",
      url: `/api/boundary/organization_boundary/check_base_year_standard/${userId}/${originalYear}/${targetYear}`,
    });
    return response.data.data;
  },

  //////// 取得基準年度的 standardId
  async getStandardIdByYear(userId, year) {
    const response = await axiosWithAbort("getStandardIdByYear", {
      method: "GET",
      url: `/api/boundary/organization_boundary/get_standard_id/${userId}/${year}`,
    });
    return response.data.data;
  },

  async hasRemovalMitigationData(year) {
    const response = await axiosWithAbort(
      `hasRemovalMitigationData:${year}`,
      {
        method: "GET",
        url: `/api/boundary/organization_boundary/has_removal_mitigation_data/${year}`,
      },
    );

    return response?.data ?? null;
  },
};
